export default class GetWorkTypePricingByWorkTypeGroupIdAndEntityIdError extends Error {

}
